import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
  },

  statusDescription: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
  },

  statusName: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '14px',
  },

  title: {
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    marginBottom: theme.spacing(1),
  },
})
